module.exports = __webpack_public_path__ + "img/logo.a79cb771.png";